import { defineComponent } from "vue";

/**
 * 渲染 `My` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const My = defineComponent({
	name: "My",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M791.06814248 343.12142833C791.06814248 187.87142833 665.83957168 62 511.42528584 62 356.94671416 62 231.71814248 187.87142833 231.71814248 343.12142833c0 74.57142832 29.44285752 146.05714248 81.9 198.77142919a279 279 0 0 0 197.80714336 82.28571416c154.41428584 0 279.64285752-125.80714248 279.64285664-281.05714336zM386.00385752 446.42857168c8.42142832-8.35714248 21.98571416-8.35714248 30.34285664-1e-8a133.07142832 133.07142832 0 0 0 192.15 0 21.47142833 21.47142833 0 0 1 30.40714336-0.57857167c8.61428584 8.35714248 8.80714248 22.05 0.5785708 30.6a176.01428584 176.01428584 0 0 1-254.12142832 0 21.72857168 21.72857168 0 0 1-0.38571416-30.02142833h1.02857168z m319.11428496 218.8285708c-66.53571416-8.22857167-130.43571416 64.86428584-193.62857081 64.86428584-63.25714248 0-126.32142832-72.45-193.62857167-64.9285708C250.361 672.97142832 108.41814248 780.84285752 81.09671416 814.59285752 53.77528584 848.21428584 46.25385752 962 124.16814248 962h774.51428584c79.13571416 0.19285752 72.25714248-113.52857168 43.00714336-147.21428584-28.41428584-33.75-170.16428584-141.23571416-236.63571416-149.46428583z" />
			</svg>
		);
	},
});

export default My;
